import { render, staticRenderFns } from "./RenewLetter.vue?vue&type=template&id=5bd14b13"
import script from "./RenewLetter.vue?vue&type=script&lang=js"
export * from "./RenewLetter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/renewletter.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports